module.exports = __webpack_public_path__ + "static/media/blog-new1.61a84444.jpg";